var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 日期选择 week table
 * @author (zhanghao14)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import { noop, classPrefix } from '../../common/util';

import THeader from './WeekHeader';
import TBody from './WeekBody';

var WeekTable = function (_Component) {
    _inherits(WeekTable, _Component);

    function WeekTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WeekTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WeekTable.__proto__ || Object.getPrototypeOf(WeekTable)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
            _this.props.onChange && _this.props.onChange(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WeekTable, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                value = _props.value,
                disableDate = _props.disableDate,
                format = _props.format,
                selectValue = _props.selectValue,
                betweenSelected = _props.betweenSelected,
                onMouseEnterDate = _props.onMouseEnterDate,
                onMouseLeaveDate = _props.onMouseLeaveDate,
                weekPicker = _props.weekPicker;

            var className = classnames(_defineProperty({}, prefixCls + '-calendar-table', true));
            var containerProps = {
                className: className
            };
            var thProps = {
                prefixCls: prefixCls,
                value: value
            };
            var tbodyProps = {
                prefixCls: prefixCls,
                value: value,
                selectValue: selectValue,
                format: format,
                disableDate: disableDate,
                onChange: this.onChange,
                betweenSelected: betweenSelected,
                onMouseEnterDate: onMouseEnterDate,
                onMouseLeaveDate: onMouseLeaveDate,
                weekPicker: weekPicker
            };
            return React.createElement(
                'table',
                containerProps,
                React.createElement(THeader, thProps),
                React.createElement(TBody, tbodyProps)
            );
        }
    }]);

    return WeekTable;
}(Component);

export default WeekTable;


WeekTable.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    value: null,
    prefixCls: classPrefix + '-date-picker',
    format: '',
    disableDate: noop,
    onChange: noop
};

WeekTable.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    prefixCls: PropTypes.string.isRequired,
    format: PropTypes.string,
    disableDate: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    selectValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    betweenSelected: PropTypes.func,
    onMouseEnterDate: PropTypes.func,
    onMouseLeaveDate: PropTypes.func,
    weekPicker: PropTypes.bool
};